<template>
  <div class="container-fluid min-vh-100 bg-locations">

    <div class="location container pt-5 my-5">

        <h1 class="display-1">Locations</h1>

        <div v-if="error">{{ error }}</div>

        <div v-if="locations">
          <!-- {{ locations.value.info.pages }} -->
          <!-- <div v-on="locations">
          {{-- locations.value.results --}}
                </div> -->
        
          <Pagination 
              :totalPages="7"
              :perPage="perPage"
              :currentPage="scurrentPage"
              @pagechanged="onPageChange">
          </Pagination>
        </div>
        
        <div v-if="locations">
            <LocationsList :locations="locations"></LocationsList>
        </div>

        <div v-if="locations">
          <!-- {{ locations.value.info.pages }} -->
          <!-- <div v-on="locations">
          {{-- locations.value.results --}}
        </div> -->
        
          <Pagination 
              :totalPages="7"
              :perPage="perPage"
              :currentPage="scurrentPage"
              @pagechanged="onPageChange">
          </Pagination>
        </div>



    </div>
</div>
</template>

<script>
import LocationsList from '@/components/LocationsList.vue'
import getLocations from '@/composables/getLocations'
import { onMounted, ref } from 'vue';
import Pagination from '@/components/Pagination/Pagination.vue';

export default {
    props:['p'],
    name:'Locations',
    components: { LocationsList, Pagination },
    setup(props) {
        // console.log('setup locations');
        // console.log(props);
        const scurrentPage = ref(1)
        const locations = ref()
        const totalPages = ref()

        if( props.p !== 'undefined' && props.p !=='NaN' && props.p>0 ) {
         scurrentPage.value = Number(props.p)
        }

        const locs = getLocations(scurrentPage.value)
        locs.load()
        // console.log('locs')
        // console.log(locs.locations)
        locations.value=locs.locations
        // console.log( locations.value.value.info )
        // const { locations , error, load } = getLocations( scurrentPage )
        // load()

        const fetching = (page) => {
          const { locations, error, load } = getLocations( page )
          load()
          return { locations, scurrentPage }
        }

        const onPageChange = (page) => {
          // locations.value=null
          // console.log('oldpage>' + page)
          var els = fetching(page)
          // console.log('elli')
          // console.log(els)
          locations.value=els.locations
          // console.log('els locations')
          // console.log(els.locations)
          scurrentPage.value=page
          // console.log('newpage>>'+scurrentPage.value)
        }

        return { fetching, locations, scurrentPage, onPageChange }
        // return { locations, /*showLocations,*/ error, scurrentPage, fetching }
    },

    mounted() {
      // window.vm = this;
    },

    methods: {
    },
    data () {
      return {
        // totalPages: 5,
        perPage:5,
        // currentPage: this.scurrentPage
      };
    },
}
</script>

<style scoped>
.bg-locations {
  background-color:cadetblue;
  background-image: var(--bs-gradient); 
}

</style>